<template>
  <!-- <div v-if="isBlackFriday">
    <div :class="$style['black-friday-banner']">
      <div :class="$style.content">
        <span :class="$style.content_1"
          >BLACK <span :class="$style.yellow">FRIDAY</span>: 2-for-1 offer</span
        >
        <span :class="$style.content_center">
          <span :class="$style.content_2">NOVEMBER</span>
          <span :class="$style.content_3">20 <span>-</span> 26</span>
        </span>
        <a
          target="_blank"
          href="https://app.any.run/plans/?utm_source=service_upperbanner&utm_medium=upperbanner_content&utm_campaign=blackfriday2023&utm_content=banner&utm_term=report_upperbanner/"
        >
          See details
        </a>
        <span :class="$style['center-gradient']"></span>
      </div>
    </div>
  </div> -->
  <div :class="[$style.container, $style['container-base']]">
    <div :class="$style.content">
      <SvgIcon src="icon-sprite.svg#banner-logo" width="155" height="52" />

      <div :class="$style.mid">
        <div :class="$style.title">analyze malware</div>

        <ul :class="$style.list">
          <li>Huge database of samples and IOCs</li>
          <li>Custom VM setup</li>
          <li>Unlimited submissions</li>
          <li>Interactive approach</li>
        </ul>
      </div>

      <a
        target="_blank"
        :class="$style.button"
        href="https://app.any.run/#register"
        id="register-referlink"
      >
        Sign up, it’s free
      </a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import SvgIcon from '../SvgIcon.vue';

export default defineComponent({
  name: 'Banner',
  data() {
    return {
      isBlackFriday: false,
    };
  },
  inject: ['root'],
  components: {
    SvgIcon,
  },
  mounted() {
    const now = new Date().getTime();
    const dateRange = {
      start: new Date(Date.parse('2023-11-19T09:00:00.000Z')).getTime(),
      end: new Date(Date.parse('2023-11-27T07:59:00.000Z')).getTime(),
    };
    const dateInRange = now >= dateRange.start && now < dateRange.end;
    const userForBF = !this.root.meta.userSignedIn || this.root.meta.userFree;

    if (dateInRange && userForBF) {
      this.isBlackFriday = true;
    }
  },
});
</script>

<style lang="scss" module>
.container-base {
  min-width: 1240px;
  height: 86px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 999;

  background-color: #181746;

  @media screen and (max-width: 1279px) {
    min-width: auto;
  }
}

.container {
  background-image: url('@/assets/images/banner-noise.png'),
    url('@/assets/images/banner-gradient.png'),
    url('@/assets/images/banner-map.png');

  background-size: 1885px, cover, calc(100% - 35px);
  background-position:
    center -186px,
    -320px center,
    center 27%;

  background-repeat: no-repeat, no-repeat, no-repeat;

  padding: 0 50px;

  @media screen and (max-width: 1700px) {
    background-size: 1885px, cover, 1370px;
    background-position:
      center -186px,
      -220px center,
      center 24%;
  }

  @media screen and (max-width: 1364px) {
    background-size: 1885px, cover, 100%;
  }

  @media screen and (max-width: 590px) {
    padding: 20px;
  }

  @media screen and (max-width: 500px) {
    padding: 0 20px;
  }

  @media print {
    display: none;
  }
}

.content {
  max-width: 1266px;
  margin: 0 auto;

  display: flex;
  width: 100%;
  justify-content: space-between;

  align-items: center;

  svg {
    display: block;
  }

  & > * {
    flex: none;
  }

  @media screen and (max-width: 1040px) {
    max-width: 490px;
    gap: 6px;
  }
}

.mid {
  justify-content: space-between;
  align-items: center;
  display: flex;
  gap: 40px;

  & > * {
    flex: none;
  }
}

.title {
  font-family: 'Montserrat Variable';
  font-weight: 800;
  font-style: normal;
  font-size: 18px;
  line-height: 135.5%;

  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #ffffff;

  @media screen and (max-width: 1364px) {
    margin-right: 0px;
  }

  @media screen and (max-width: 1279px) {
    display: none;
  }
}
.list {
  display: flex;
  flex-wrap: wrap;
  max-width: 530px;
  gap: 6px;
  justify-content: space-between;

  @media screen and (max-width: 1040px) {
    display: none;
  }
}

.list,
.list * {
  font-family: 'Montserrat Variable';

  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 125%;

  color: #ffffff;

  li {
    position: relative;

    margin-left: 15px;

    min-width: 171px;

    &::before {
      content: '>';
      position: absolute;

      font-family: 'Teko';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 23px;

      display: flex;
      align-items: center;
      text-align: center;

      color: #e7a5a4;
      top: 1px;

      right: calc(100% + 5px);
      text-shadow: 0px 0px 5px #e35653;
    }
  }
}

.button {
  background: #00bfb1;
  border-radius: 3px;
  padding: 9px 36px;

  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.02em;
  white-space: nowrap;

  color: #ffffff;
  text-align: center;

  display: block;

  &:hover {
    background: #00d3c4;
  }
  &:active {
    background: #00ac9f;
  }

  @media screen and (max-width: 500px) {
    flex-shrink: 1;
    width: 100%;
    max-width: 160px;
    padding: 9px 8px;
  }
}

.black-friday-banner {
  display: block;
  height: 56px;
  background: #000;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.black-friday-banner .center-gradient {
  width: 938px;
  height: 67px;
  background-image: url('@/assets/images/eclipse.png');
  pointer-events: none;
  z-index: -1;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  border-radius: 50%;
}
.black-friday-banner::before {
  content: '';
  position: absolute;
  left: 40px;
  top: -82px;
  display: block;
  width: 360px;
  height: 220px;
  background: url('@/assets/images/percent_1.png') no-repeat center center;
  background-size: contain;
  pointer-events: none;
  z-index: -1;
}
.black-friday-banner::after {
  content: '';
  position: absolute;
  top: -32px;
  right: 71px;
  display: block;
  width: 326px;
  height: 150px;
  background: url('@/assets/images/percent_2.png') no-repeat center center;
  background-size: contain;
  pointer-events: none;
  z-index: -1;
}
.black-friday-banner .content {
  font-family: 'Montserrat Variable';
  color: #fff;
  letter-spacing: 0.02em;
  max-width: 1200px;
  margin: 0 auto;
  height: 56px;
  text-align: center;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.black-friday-banner .content .content_1 {
  font-weight: 800;
  font-style: italic;
  font-size: 22px;
  line-height: 24px;
  margin-right: 40px;
}
.black-friday-banner .content .content_1 .yellow {
  color: #ffcf55;
}
.black-friday-banner .content .content_2 {
  margin-right: 10px;
}
.black-friday-banner .content .content_2,
.black-friday-banner .content .content_3 {
  font-weight: 700;
  font-style: italic;
  font-size: 18px;
  line-height: 24px;
}
.black-friday-banner .content a {
  display: block;
  border: 1px solid #f6d76a;
  border-radius: 3px;
  color: #f6d76a;
  font-weight: 600;
  padding: 4px 26px;
  margin-left: 40px;
}
.black-friday-banner .content a:hover {
  text-decoration: none;
  background: #f6d76a;
  color: #2c0f02;
}

@media screen and (max-width: 1279px) {
  .black-friday-banner {
    height: 82px;
  }
  .black-friday-banner::before {
    top: -69px;
    left: 10px;
    width: 375px;
  }
  .black-friday-banner::after {
    right: 10px;
  }
  .black-friday-banner .content {
    height: 82px;
  }
  .black-friday-banner .content_1 {
    width: 186px;
  }
  .black-friday-banner .content_center {
    width: 115px;
  }
}

@media screen and (max-width: 560px) {
  .black-friday-banner {
    height: 92px;
  }
  .black-friday-banner::before {
    top: -64px;
    left: -53px;
    width: 429px;
  }
  .black-friday-banner::after {
    right: -52px;
  }
  .black-friday-banner .content {
    flex-wrap: wrap;
    padding: 0 10px;
  }
  .black-friday-banner .content a {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 4px;
  }
}

@media screen and (max-width: 400px) {
  .black-friday-banner .content .content_1 {
    margin-right: 20px;
  }
  .black-friday-banner .content_center {
    margin-right: 15px;
  }
}
</style>
